import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Subject, of } from 'rxjs';
import { getApiUrl } from '../../core/helpers/rest-utils';
import { CustomerLocation } from './google-places-search.component';

@Injectable({
    providedIn: 'root'
})
export class GooglePlacesSearchService {
    selectedPlace: Subject<any> = new Subject();
    selectedPlaceId: Subject<string> = new Subject();
    userLocation: any = null;
    userLocationLatLon: { lat: number | string, lon: number | string } = { lat: 45.5152, lon: -122.6784 };
    constructor(private http: HttpClient) {
        this.fetchLocation();
    }

    getPlacePredictions(data: any) {
        if (!data) {
            return of([]);
        }
        data['location'] = this.userLocationLatLon;
        return this.fetchPlacePredictions(data);
    }

    getPlaceDetails(placeId: any) {
        return this.fetchPlaceDetails(placeId);
    }

    private fetchPlacePredictions(data: any) {
        return this.http.post(`${getApiUrl()}places/predictions`, data).pipe(map((response: any) => response?.data?.predictions));
    }

    private fetchPlaceDetails(placeId) {
        return this.http.get(`${getApiUrl()}places/${placeId}`).pipe(map((response: any) => response.data));
    }

    private fetchLocation(): void {
        this.http.get<CustomerLocation>('https://extreme-ip-lookup.com/json/?key=8xTSqsy0DdzfxyHnCQdS')
            .pipe(map((response: any) => response.data))
            .subscribe((location: CustomerLocation) => this.setUserLocationLatLon(location));
    }

    private setUserLocationLatLon(location?: CustomerLocation): void {
        const lat = location?.lat || 45.5152;
        const lon = location?.lon || -122.6784;
        this.userLocationLatLon = { lat, lon };
    }
}